import React from 'react'
import * as fn from '../../../../../helper/uiFunctions';
import SarasTooltip from '../../../../../library/notifications/SarasTooltip';

const ProdGridInfoDRow = ({formObject, viewData, rowKey}) => {

    const docStyle = formObject.getValueFromKey(viewData, "rowValues.prodStatus.dataList.colCssStyle", "{}");
    const priorityStyle = formObject.getValueFromKey(viewData, "rowValues.prodPriority.dataList.colCssStyle", "{}");

    const prodId = viewData.rowValues.prodId;
    const docModule = formObject.getValueFromKey(prodId, "dataList.module", formObject.docModule);
    const docView = formObject.getValueFromKey(prodId, "dataList.view", formObject.docView);
    const valLDT = formObject.getValueFromKey(prodId, "dataList.valLDT", 0);
    const prodLink = fn.getShowDocumentLink(valLDT, prodId.val, "", 1, docModule, docView);

    const getJsonStyle = (styleString) => {
        if(styleString){
            return JSON.parse(styleString);
        }

        return {}
    }

    const getTooltip = () => {
        return (
            <div className='uiTooltip'>
                <div><span>Order Id: </span>{viewData.rowValues.prodId.val}</div>
                <div><span>Qty: </span>{viewData.rowValues.prodQty.valF}</div>
                <div><span>Required On: </span>{viewData.rowValues.reqDate.val}</div>
                <div><span>Order Status: </span>{viewData.rowValues.prodStatus.valF}</div>
            </div>
        )
    }
    // console.log("debug ", viewData.rowValues);
    // console.log("debug ", docStyle, priorityStyle, JSON.parse(docStyle), JSON.parse(priorityStyle));

    return (
        <li className='uiDetailRow'>
            <SarasTooltip title={getTooltip()}>
                <a href={prodLink} target="__blank">
                    <span className='uiProdInfoLeft' 
                    style={getJsonStyle(docStyle)}>{viewData.rowValues.prodQty.valF}</span>

                    <span className='uiProdInfoRight' 
                    style={getJsonStyle(priorityStyle)}>{viewData.rowValues.prodPriority.valF}</span>
                </a>
            </SarasTooltip>
        </li>
    );

}

//starting with capital letter will ensure this is treated as a component
const ProdGridInfoD = ({formObject, viewData, rowKey}) => {
    
    // console.log("JO Details", viewData);

    return (
        <div className="saras-cell">
            <ul className='uiOSProdDetail'>
                {Object.values(viewData.childRows).map((row,index)=>(
                    <ProdGridInfoDRow key={index} formObject={formObject} viewData={row} />
                ))
                }
            </ul>
        </div>
    );
}

export default ProdGridInfoD
